<template>
    <transition name="fade">
        <div class="col-sm-6 year-overlay" v-if="visible">
            <div class="year-modal">
                <div class="year-body">
                    <h2>baujahr?</h2>
                    <p>wählen Sie jetzt bitte das Baujahr Ihres Autos.</p>
                    <table class="table">
                        <tbody>
                        <tr>
                            <th>von</th>
                            <th>bis</th>
                            <th></th>
                            <th></th>
                        </tr>
                        <tr v-for="year in years" :data-id="year.id" @click="onSelected">
                            <td>{{ year.validFrom }}</td>
                            <td><span v-if="year.validTo != '0000-00-00'">{{ year.validTo }}</span></td>
                            <td></td>
                            <td>{{ year.name }}</td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="close" :data-id="carId" @click="closeModal">x</div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        years: {
            required: true,
            default: []
        },
        carId: {
            type: [String, Number],
            required: true,
            default: null
        }
    },

    data() {
        return {
            visible: false,
            year: null
        }
    },

    methods: {

        onSelected({currentTarget}) {
            this.visible = false;
            this.year = currentTarget.dataset.id;

            App.event.fire('car.year.selected', {
                year: this.year,
                car: this.carId
            });

            new Form({id: this.year})
                .post('/api/types')
                .then((types) => {
                    App.event.fire('car.types.loaded', {
                        types: types,
                        car: this.carId
                    });
                });
        },

        closeModal() {
            this.visible = false;
        }
    },

    created() {
        App.event.listen('car.open.years', (id) => {
            this.visible = (id == this.carId);
        });
    }
}
</script>

